// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';

import Australia from '../_raw/flag/icon_flag_australia.png';

export default () => <img src={Australia} alt="Australia" />;
